module.exports = __webpack_public_path__ + "img/bq.10d31cc2.svg";